module.exports = __webpack_public_path__ + "static/media/letter_0@3x.15a2739b.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_0@3x.png
// module id = 576
// module chunks = 0